import { createStores } from './store/utils';
import { ActiveProgram } from '../types/casino-payback/types';
import { CasinoGame } from '../services/casino/types';

export const casinoPaybackStore = createStores({
    casinoPayback: null as ActiveProgram | null,
    games: [] as CasinoGame[],
    isExpired: false,
});
